import { decodeHtmlEntities } from "@simplyk/common";
import sanitizeHtml from "sanitize-html";

const BLOCK_END_PATTERN = /<\/(p|li|div|h[1-6])>|<br\s*\/?>/gi;

export const getMissionPlainText = (description: string | null | undefined): string => {
  if (!description) {
    return "";
  }

  const html = description.replace(/^LXCL:/, "").replace(BLOCK_END_PATTERN, "$& ");
  const text = decodeHtmlEntities(sanitizeHtml(html, { allowedTags: [] }));
  return text.replace(/[\s ]+/g, " ").trim();
};
